module.exports = __webpack_public_path__ + "static/media/caret-circle-down.b1ac3d7f.svg";